import React from 'react';
import PropTypes from 'prop-types';
import {Box} from '@mui/material';
import useIndentUnderTab from './useIndentUnderTab';
import {OUTLINED_BOX_SX, TopLineAroundTab} from './tabOutline';

// Maria, 18 October 2026: a sub-tab's list is in a box with a pale green outline under the row of tabs, with a little
// space above the first row. Maria, 19 October 2026: the box starts at the left-hand edge and is the full width of the
// page, with its top line left open under its tab.
// 'fill' (a wide table): the box takes the rest of the width, or ends at 'endTabTestId', and the table scrolls sideways
// inside it with its actions column kept in view.
// 'closedTop' (Maria, 19 October 2026): a plain top edge, for a list under the rounded tabs inside a staff profile's Forms
// 'band' (Maria, 19 October 2026): the first row inside the box is part of the open tab; the box gives its children
// '--open-tab-end' and leaves its own top line to them
const UnderTab = ({tabTestId, endTabTestId, fill, closedTop, band, children}) => {
    const [ref, indent, measured, toEndTab, , openTab] = useIndentUnderTab(tabTestId, endTabTestId);

    return (
        <Box
            ref={ref}
            sx={{
                visibility: measured ? 'visible' : 'hidden',
                ml: `${indent}px`,
                mr: 2,
                mb: 2,
                ...OUTLINED_BOX_SX,
                // with 'band', the right-hand edge starts at the foot of the band, drawn by the list under it
                ...(band && openTab ? {borderRight: 'none', backgroundColor: 'transparent'} : {}),
                overflow: 'hidden',
                // a table starts straight under its tab, so its green heading row meets the green open tab
                pt: fill ? 0 : 0.75,
                // Maria, 19 October 2026: every box is the full width of the page, on student and staff profiles
                width: `calc(100% - ${indent + 16}px)`,
                // a box ending at a named tab can reach the right-hand edge, as that tab may
                maxWidth: endTabTestId && toEndTab ? `calc(100% - ${indent}px)` : `calc(100% - ${indent + 16}px)`,
                ...(band && openTab ? {'--open-tab-end': `${Math.max(0, openTab.end - 2)}px`} : {})
            }}
        >
            {!(band && openTab) && <TopLineAroundTab openTab={closedTop ? null : openTab}/>}
            <Box sx={{width: '100%'}}>
                {children}
            </Box>
        </Box>
    );
};

UnderTab.propTypes = {
    tabTestId: PropTypes.string.isRequired,
    endTabTestId: PropTypes.string,
    fill: PropTypes.bool,
    closedTop: PropTypes.bool,
    band: PropTypes.bool,
    children: PropTypes.node
};

export default UnderTab;
